<div class="refresh">
  <p class="info">{{ content }} :</p>
  <p class="calendar">{{ date | date : dateType.DATE | emptyFormat }}</p>
</div>
